import React, { useEffect, useState, Fragment } from 'react'
import { Container, Tab, Tabs } from 'react-bootstrap'
import { Auth } from 'recupero-comunes'
import { useDispatch, useSelector } from 'react-redux'
import { clearComboDocument, obtenerDataCarpeta, obtenerUrlCarpeta } from '../../store/actions/carpeta-digital-ation'
import MyIFrame from './iFrame'
import VisorCarpeta from './visorCarpeta'

const TabsComponent = ({prototipo,sendUrl, setSendUrl,op,resetCombo,docRef, origen, region, myUrlBase, folder}) => {

  const [key, setKey] = useState(prototipo===4?'implicado1':'asegurado')
  const [docsubkey, setDocsubkey] = useState(0)
  const data_carpeta = useSelector((state) => state.CarpetaDigitalReducer)
  const { cfg_form30, datosImplicadoTercero, urlCarpeta,limpiar,respuestaUrl} = data_carpeta
  const data_recepciona = useSelector((state) => state.casoGeneralReducer)
  const { llaves} = data_recepciona
  const dispatch = useDispatch()
  const { token } = Auth.currentUser()

  /*useEffect(()=>{
    if (datosImplicadoTercero) {
      datosImplicadoTercero.datosImplicadoTercero.map((implicado, index) => {
        console.log("implicado: ", implicado);
      });      
    }
  },[datosImplicadoTercero])*/

  useEffect(()=>{
    if(llaves){
      if( prototipo===1){
        let localQuery = new Buffer(`op=${'cd-view'}&dockey=${llaves && llaves["idCaso"]}&docsubkey=${0}&owner=${llaves && llaves['idOrgCaso']}&user=${llaves && llaves['idUsuario']}&region=${region}&origenusr=${origen}`)
        dispatch(obtenerUrlCarpeta(localQuery.toString('base64')))
        .then(()=>{
          let query = Buffer.from(JSON.stringify({"origen":"1"})).toString('base64')
          dispatch(obtenerDataCarpeta(query))
        })  
      }
    }
  },[dispatch, llaves])

  useEffect(()=>{
    if(urlCarpeta && respuestaUrl ){
      setSendUrl(`${myUrlBase}?q=${urlCarpeta}&t=${token.accessToken}`)
    }
   
  },[urlCarpeta,respuestaUrl])

  useEffect(()=>{
    if(limpiar){
      if(prototipo===4 ){       
        //console.log("LLAVES: ", llaves);
        let localQuery = new Buffer(`op=${'cd-view'}&dockey=${llaves && llaves["idCaso"]}&docsubkey=${llaves && llaves["idImplicado"]}/${folder}&owner=${llaves && llaves['idOrgCaso']}&user=${llaves && llaves['idUsuario']}&region=${region}&origenusr=${origen}`)
        dispatch(obtenerUrlCarpeta(localQuery.toString('base64')))
      } 
      let docs=limpiar==='asegurado'?0:limpiar==='implicado1'?1:limpiar==='implicado2'?2:limpiar==='implicado3'?3:4
      if(op==='cd-view' || prototipo===1){
        let localQuery = new Buffer(`op=${'cd-view'}&dockey=${llaves && llaves["idCaso"]}&docsubkey=${docs}&owner=${llaves && llaves['idOrgCaso']}&user=${llaves && llaves['idUsuario']}&region=${region}&origenusr=${origen}`)
        dispatch(obtenerUrlCarpeta(localQuery.toString('base64'))) 
      }
    }
  },[limpiar,respuestaUrl])
 
  return (
    <>
      <style type='text/css'>
        {`
          .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
          color: white;
          background-color: #01CECA;
         
          }

          .nav-tabs {
              border-Bottom: 1px solid #253B6D;
              
          }
          .nav-item{
           
   
            color: #d9d9d9;
            border: 1px solid #01CECA;
            border-radius:5px 5px 0px 0px;  
            margin-right:2px;
            border-Bottom:none;            
            
          }
          .nav-tabs .nav-link:hover{
            color:white;
              background-color: #01CECA;
          }
     `}
      </style>
<Container>
      <Tabs
        className='nav-tabs'
        activeKey={key}
        id='uncontrolled-tab-example'
        onSelect={(k) => {
          //console.log("tab key: docsubkey: ", k, docsubkey);
          setDocsubkey(k==='asegurado'?0:k==='implicado1'?1:k==='implicado2'?2:k==='implicado3'?3:4)
          setKey(k)
          setSendUrl('')
          dispatch(clearComboDocument(k))         
        }}
      >
       {prototipo!==4? <Tab.Pane        
          eventKey='asegurado'
          title={cfg_form30 ? cfg_form30.cfg_form30['modalcd-tab-asegurado'] : ''}
          // onClick={() =>setSendUrl('')}
        >
         {op==='cd-upload' && prototipo!==1 ? <VisorCarpeta idImplicado={0} setSendUrl={setSendUrl} resetCombo={resetCombo} docRef={docRef} prototipo={prototipo} sendUrl={sendUrl} region={region}/>:null }
        </Tab.Pane>:null}
        {datosImplicadoTercero && datosImplicadoTercero.datosImplicadoTercero.map((implicado, index) => {
          return (
            <Tab.Pane
              eventKey={'implicado'+implicado.IdImplicado}
              title={cfg_form30 && implicado ? `${cfg_form30.cfg_form30['modalcd-tab-tercero']} ${implicado['IdImplicado']} ${implicado['NombreImplicado']}` : ''}
              // onClick={() =>setSendUrl('')}
            >
            {op==='cd-upload' && prototipo!==1 && prototipo!==4?<VisorCarpeta idImplicado={implicado.IdImplicado} setSendUrl={setSendUrl} resetCombo={resetCombo} docRef={docRef} prototipo={prototipo} sendUrl={sendUrl} region={region}/>:null }
            </Tab.Pane>
          )       
         })
        }
      </Tabs>
      {sendUrl!=='' && <MyIFrame urlDocumento={sendUrl} op={op} prototipo={prototipo}/>}
      </Container>
    </>
  )
}

export default TabsComponent
